export default function unique() {
  return false;
}

unique.message = function message(value, options = {}) {
  return options.message || 'não pode ser repetido';
};
